let messages = [
    {
      id: 1,
      primary: 'Road Closure',
      secondary: "The road 123 between A and B has been closed for important maintanance work, please use alternative routes",
      icon: 1,
    },
    {
      id: 2,
      primary: 'Community Meeting',
      secondary: "An information meeting about social initiatives for 2020...",
      icon: 2,
    }
]

export default messages;